
import * as defaultImport from "xmlserializer";
export * from "xmlserializer";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
